import Services from "../Services";

export default class RegistererOnLoadCallback {
    static $services = Services;

    static boot(callback, ...params) {
        RegistererOnLoadCallback.$services.onLoadCallbacks.boot.push({callback: callback, arguments: params})
    }

    static booting(callback, ...params) {
        RegistererOnLoadCallback.$services.onLoadCallbacks.booting.push({callback: callback, arguments: params})
    }

    static booted(callback, ...params) {
        RegistererOnLoadCallback.$services.onLoadCallbacks.booted.push({callback: callback, arguments: params})
    }
}